import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import GLOBAL from './common/global.js'
import VueJsonp from 'vue-jsonp'
import axios from 'axios'
import Share from 'vue-social-share'
import { Cloud } from "@cyanmoon8/lfcloud";
import { lfRequest } from "./common/request.js"
import {
  PID,
  APP_SPLIT_KEY,
  APP_SPLIT_SECRET,
  TABLE_PREFIX,
} from "./config/constVariables.js";
// import 'vue-social-share/dist/client.css';


Vue.use(VueJsonp)
Vue.use(Share)

axios.defaults.baseURL = GLOBAL.baseUrl; // 配置接口地址
Vue.prototype.$axios = axios;
Vue.prototype.$Cloud = new Cloud(
{
    pid: PID,
    app_split_key: APP_SPLIT_KEY,
    app_split_secret: APP_SPLIT_SECRET,
    table_prefix: TABLE_PREFIX,
  },
  lfRequest
);
// 参数：method（API名），data（请求参数对象）
Vue.prototype.jsp = function(method, data) {
	// baseUrl就是服务器地址
	const baseUrl = 'https://erp.lfwellness.cn/';
	let url = `${baseUrl}${method}?`;
	// jsonp请求参数和get方法类似，都是params的方式拼接
	for (let item in data) {
		url += `&${item}=${data[item]}`;
	}
	return this.$jsonp(url);
};
Vue.config.productionTip = false

Vue.prototype.GLOBAL = GLOBAL;

Vue.use(require('vue-wechat-title')) //引入title插件

Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
